import React, { useContext, useMemo } from "react";
import "./index.css";
import { AtendimentoContext } from "../../../../contexts/AtendimentoContext";
import { TipoAtendimentoContext } from "../../../../contexts/TipoAtendimentoContext";
import caAPI from "../../../../services/caAPI";
import { usePromiseTracker } from "react-promise-tracker";
import { DommusDroppable } from "../../../../components/DommusDroppable";

const componenteLoadingLista = (
  <div className="lista-tipos-atendimento-skeleton">
    <div className="item-tipo-atendimento-skeleton skeleton-animation"></div>
    <div className="item-tipo-atendimento-skeleton skeleton-animation"></div>
    <div className="item-tipo-atendimento-skeleton skeleton-animation"></div>
    <div className="item-tipo-atendimento-skeleton skeleton-animation"></div>
    <div className="item-tipo-atendimento-skeleton skeleton-animation"></div>
    <div className="item-tipo-atendimento-skeleton skeleton-animation"></div>
    <div className="item-tipo-atendimento-skeleton skeleton-animation"></div>
    <div className="item-tipo-atendimento-skeleton skeleton-animation"></div>
  </div>
)

export function TiposAtendimentosLista(){
  const {tiposAtendimento} = useContext(TipoAtendimentoContext);
  const {promiseInProgress: isLoadingTiposAtendimento} = usePromiseTracker({area: "loading-tipos-atendimentos"});
  const { tipoAtendimentoSelecionado, setTipoAtendimentoSelecionado, totaisPorTipoAtendimento, handleExecutaPesquisaTelaPrincipal, buscandoAtendimentos} = useContext(AtendimentoContext);
  
  const handleAlterarTipoAtendimento = (tipo)=>{
    if(buscandoAtendimentos){
      return;
    }
    setTipoAtendimentoSelecionado(tipo?.id ?? null);
    const filtros = JSON.parse(caAPI.getLocalState('filtros'));
    filtros.tipo_atendimento = !!tipo?.id ? [{label:tipo?.descricao ,value: tipo?.id}] : null;
    handleExecutaPesquisaTelaPrincipal(filtros);
  }

  const caixaEntrada = useMemo(()=>{
    return tiposAtendimento.find((item) => item?.descricao?.toLowerCase() === "não especificado");
  },[tiposAtendimento])


  return (
    <div className={`lista-tipos-atendimento-section ${buscandoAtendimentos ? "filtro-bloqueado" : ""}`}>
      {isLoadingTiposAtendimento ? 
        componenteLoadingLista
      :
        (
          <>
            <div 
              className={`item-tipo-atendimento ${!tipoAtendimentoSelecionado ? "selecionado" : ""}`} 
              onClick={()=>{
                handleAlterarTipoAtendimento(null)
              }}
            >
              Todos
              <span className="item-total">{totaisPorTipoAtendimento?.total ?? 0}</span>
            </div>
            <DommusDroppable id={`tipo_atendimento-${caixaEntrada?.id}`}>
              <div 
                className={`item-tipo-atendimento item-caixa-entrada ${tipoAtendimentoSelecionado === caixaEntrada?.id ? "selecionado" : ""}`} 
                onClick={()=>{
                  handleAlterarTipoAtendimento(caixaEntrada)
                }}
              >
                Caixa de entrada
                <span className="item-total">{totaisPorTipoAtendimento[caixaEntrada?.id] ?? 0}</span>
              </div>
            </DommusDroppable>
            {tiposAtendimento.filter((item) => item.descricao.toLowerCase() !== "não especificado").map((item, index)=>{
              return(
                <DommusDroppable key={index} id={`tipo_atendimento-${item.id}`}>
                  <div 
                    key={index} 
                    className={`item-tipo-atendimento ${tipoAtendimentoSelecionado === item.id ? "selecionado" : ""}`} 
                    onClick={()=>{
                      handleAlterarTipoAtendimento(item)
                    }}
                  >
                    {item?.descricao} 
                    <span className="item-total">{totaisPorTipoAtendimento[item?.id] ?? 0}</span>
                  </div>
                </DommusDroppable>
              )
            })}
          </>
        )
      }
    </div>
  )
}
